import { render, staticRenderFns } from "./PublicPop.vue?vue&type=template&id=0b273824&scoped=true"
import script from "./PublicPop.vue?vue&type=script&lang=js"
export * from "./PublicPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b273824",
  null
  
)

export default component.exports